import { c as _c } from "react/compiler-runtime";
import type { ProductHit } from "@/lib/search/types";
import { PlpProductCard } from "./PlpProductCard";
interface Props {
  hits: ProductHit[];
  showMatchedAttributes?: boolean;
}
export function PlpProductGrid(t0) {
  const $ = _c(7);
  const {
    hits,
    showMatchedAttributes
  } = t0;
  if (hits.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== hits || $[1] !== showMatchedAttributes) {
    let t2;
    if ($[3] !== showMatchedAttributes) {
      t2 = (hit, index) => <PlpProductCard key={hit.sku} hit={hit} position={index + 1} showMatchedAttributes={showMatchedAttributes} />;
      $[3] = showMatchedAttributes;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = hits.map(t2);
    $[0] = hits;
    $[1] = showMatchedAttributes;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="plp-product-grid">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}